<template>
  <div class="boxs">
    <!-- 123 -->
    <iframe ref="webgl" :src="src"></iframe>
    <!-- <unity
      src="@/../static/LXwebgl/Build/LXwebgl.json"
      width="100%"
      height="100%"
      unityLoader="@/../static/LXwebgl/Build/UnityLoader.js"
      ref="unityvue"
    ></unity> -->
  </div>
</template>

<script>
// import Unity from "vue-unity-webgl";

export default {
  // components: { Unity },

  data() {
    return {
      src: "",
    };
  },
  created() {
    if (this.$route.query.token) {
      this.src = `/static/LXwebgl/index.html?token=${this.$route.query.token}&expert=${this.$route.query.expert}`;
    } else {
      this.src = `/static/LXwebgl/index.html?token=${this.$store.state.usuerdata.token}&expert=${this.$route.query.expert}`;
    }

    // window.ReportReady = () => {
    //   this.$refs.unityvue.message(
    //     "WebCommunication",
    //     "SetToken",
    //     this.$store.state.usuerdata.token
    //   );
    // };
  },
};
</script>
<style scoped>
iframe,
.boxs {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/unity.vue